import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadingButton } from '@mui/lab';
import { pxToRem } from '@/theme/typography';
import { SxProps } from '@mui/material';

interface DialogFormButtonProps {
  handleSave: () => void;
  label: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  customSx?: SxProps;
  customComponent?: () => JSX.Element;
}

export const DialogFormButton: FC<DialogFormButtonProps> = ({
  handleSave,
  label,
  isLoading = false,
  isDisabled = false,
  customSx,
  customComponent,
}) => {
  return (
    <LoadingButton
      id='credit-card-save'
      variant='contained'
      fullWidth
      disabled={isDisabled}
      loading={isLoading}
      onClick={handleSave}
      sx={{
        height: {
          tablet: pxToRem(56),
          mobile: '56px',
        },
        ...customSx,
      }}
    >
      {customComponent?.()}
      <FormattedMessage id={label} />
    </LoadingButton>
  );
};
